import { ApiClientService, EntityApiService } from '@dfl/react-security';
import { ITerms } from 'modules/cms/terms/interfaces';

class TermsService extends EntityApiService<ITerms> {
  findActive = (): Promise<ITerms> => {
    return this.handleResponse(ApiClientService.get('/ms-cms/api/public/terms-and-conditions/active')) as Promise<ITerms>;
  };
}

export default new TermsService('/ms-cms/api/admin/terms-and-conditions');
